import { Table } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import PaginationComponent from "../../common/Pagination/PaginationComponent";
import MultiSelectDropdown from "../../components/MultiSelectDropdown/MultiSelectDropdown";
import { SECTIONS_ORDER } from "../../config/constants";
import { FaInfo } from "react-icons/fa";
import { getAllMetricsDefinition } from "../../services/userService";
import { formatDecimalToFixed2 } from "../../utils/utils";
import TabComponent from "../../components/tabs/TabComponent";
import BarChart from "../../common/BarChart/BarChart";

import "./ComparisionView.scss";

const ComparisionView = ({
  filterComparisonData,
  brandFilterOptions,
  filteredComparisonData,
  compareFilterCategories,
  getColor,
  projectId,
}) => {
  const [selectedMetricDesc, setSelectedMetricDesc] = useState(null);
  const [metricsDesc, setMetricsDesc] = useState([]);
  const [compareSelectedFilterCategories, setCompareSelectedFilterCategories] =
    useState([]);
  const [compareSelectedFilterBrands, setCompareSelectedFilterBrands] =
    useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [chartsData, setChartsData] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [brandColors, setBrandColors] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Get unique brands
  const uniqueBrands = Array.from(
    new Set(filteredComparisonData.map((row) => row.brandName))
  ).sort((a, b) => a.localeCompare(b));
  const totalPages = Math.ceil(uniqueBrands.length / itemsPerPage);

  const brandsToDisplay = uniqueBrands?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleCompareFilterCategory = (selectedOptions) => {
    setCompareSelectedFilterCategories(selectedOptions);
    filterComparisonData(selectedOptions, compareSelectedFilterBrands);
  };

  const handleCompareFilterBrand = (selectedOptions) => {
    setCompareSelectedFilterBrands(selectedOptions);
    filterComparisonData(compareSelectedFilterCategories, selectedOptions);
  };

  const fetchMetricsDefinition = async (
    metric_name,
    platform_name,
    metricsId
  ) => {
    try {
      if (selectedMetricDesc === metric_name) {
        setSelectedMetricDesc(null);
        setMetricsDesc("");
      } else {
        const metricsDescData = await getAllMetricsDefinition(
          metricsId,
          platform_name
        );
        if (metricsDescData) {
          setMetricsDesc(metricsDescData?.definition);
          setSelectedMetricDesc(metric_name); // Set the clicked metric as selected
        }
      }
      // const metricsDescData = await getAllMetricsDefinition(metric_name, platform_name); // Pass the platform name here
      // if (metricsDescData) {
      //   setMetricsDesc(metricsDescData?.definition)
      //   setSelectedMetricDesc(metric_name);
      // }
    } catch (error) {
      console.error("Error while fetching or mapping metrics data:", error);
    }
  };

  // Group data by metricname
  const groupedData = filteredComparisonData.reduce((acc, row) => {
    if (!acc[row.metricname]) {
      acc[row.metricname] = [];
    }
    acc[row.metricname].push(row);
    return acc;
  }, {});

  const sortedGroupedData = Object.keys(groupedData)?.sort((a, b) => {
    const sectionA =
      groupedData[a][Object.keys(groupedData[a])[0]]?.sectionName || "";
    const sectionB =
      groupedData[b][Object.keys(groupedData[b])[0]]?.sectionName || "";
    return SECTIONS_ORDER.indexOf(sectionA) - SECTIONS_ORDER.indexOf(sectionB);
  });

  // comparison Graphical view

  const fetchWeightsData = async (projectId) => {
    try {
      processGraphicViewData(filteredComparisonData, selectedSection);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchWeightsData(projectId);
  }, [projectId]);

  const processGraphicViewData = (filteredComparisonData, selectedSection) => {
    const filterByWeights = filteredComparisonData
      .filter((metric) => metric.weights !== null)
      .filter(
        (metric) =>
          metric.sectionName === selectedSection ||
          (!selectedSection && metric.sectionName === "Marketplace")
      );
    console.log("filterByWeights", filterByWeights);

    const groupedSectionData = filterByWeights.reduce((acc, item) => {
      const key = `${item.sectionName}-${item.platformname}-${item.metricname}`;
      if (!acc[key]) {
        acc[key] = {
          section: item.sectionName,
          platform: item.platformname,
          metric: item.metricname,
          brands: [],
          weights: item.weights,
          benchmarkValue: item.benchmarkValue,
        };
      }
      acc[key].brands.push({
        brand: item.brandName,
        normalized: item.normalized,
      });
      return acc;
    }, {});
    console.log("groupedSectionData::", groupedSectionData);
    const sortedMetrics = Object.values(groupedSectionData)
      .sort((a, b) => b.weights - a.weights)
      .slice(0, 12);

    console.log("sortedMetrics", sortedMetrics);
    const chartData = sortedMetrics.map((metric) => ({
      section: metric.section,
      platform: metric.platform,
      metric: metric.metric,
      // benchmarkValue: metric.benchmarkValue,
      brands: metric.brands.map((b) => ({
        brand: b.brand,
        normalized: b.normalized,
      })),
    }));
    setChartsData(chartData);
    generateBrandColors(chartData);
  };
  console.log("chartData main", chartsData);
  // const groupedByMetric = filteredComparisonData.reduce((acc, item) => {
  //   const key = item.metricname;
  //   if (!acc[key]) {
  //     acc[key] = [];
  //   }
  //   acc[key].push(item);
  //   return acc;
  // }, {});

  const generateBrandColors = (chartData) => {
    const colors = {};
    const colorPalette = [
      "#00CA71",
      "#5B5AD6",
      "#FFCB03",
      "#EE194F",
      "#1C79D3",
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#4BC0C0",
      "#9966FF",
      "#FF9F40",
    ];

    // let index = 0;
    // chartData.forEach((metric) => {
    //   const brand = metric.brandName;
    //   if (!colors[brand]) {
    //     colors[brand] = colorPalette[index % colorPalette.length];
    //     index++;
    //   }
    // });
    chartData.forEach((metric) => {
      metric.brands.forEach((brandData, index) => {
        if (!colors[brandData.brand]) {
          colors[brandData.brand] = colorPalette[index % colorPalette.length];
        }
      });
    });
    setBrandColors(colors);

    // return colors;
  };
  // const brandColors = generateBrandColors(filteredComparisonData);
  const handleComparisonGraphData = (type) => {
    setSelectedSection(type);
    processGraphicViewData(filteredComparisonData, type);
  };

  const filteredChartsData = selectedSection
    ? chartsData.filter((data) => data.section === selectedSection)
    : chartsData;
  const emptyCharts = Array.from(
    { length: 12 - filteredChartsData.length },
    () => ({
      platform: "",
      metric: "",
      brands: [{ brand: "", normalized: 0 }],
    })
  );

  const displayChartsData = [...filteredChartsData, ...emptyCharts].filter(
    (data) =>
      data.brands.some((brand) => brand.normalized && brand.normalized > 0)
  );

  const nestedTabs = [
    {
      label: "Table view",
      content: (
        <>
          <ul className="legend">
            <li> Marketplace</li>
            <li> Digital Spends</li>
            <li> Socialwatch</li>
            <li> Organic Performance</li>
          </ul>

          {filteredComparisonData?.length > 0 ? (
            <>
              <Table responsive bordered className=" comparision-table">
                <thead>
                  <tr>
                    <th className="sticky-col" style={{ width: "150px" }}>
                      Section
                    </th>
                    <th className="sticky-col" style={{ width: "150px" }}>
                      Platform
                    </th>
                    <th className="sticky-col" style={{ width: "200px" }}>
                      Metric
                    </th>

                    {brandsToDisplay.map((brand) => {
                      const row = filteredComparisonData.find(
                        (data) => data.brandName === brand
                      );
                      return (
                        <th key={brand} style={{ width: "100px" }}>
                          {brand}
                          {row?.categoryName && (
                            <span className="brand-category">
                              {" "}
                              ({row.categoryName})
                            </span>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {sortedGroupedData.map((metricName) => {
                    const firstRow = groupedData[metricName][0]; // Representative row for static data
                    const rows = groupedData[metricName];
                    return (
                      <tr key={metricName}>
                        <td
                          className="sticky-col"
                          style={{
                            width: "150px",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              backgroundColor: getColor(firstRow?.sectionName),
                              marginRight: "5px",
                            }}
                          ></span>
                          {firstRow?.sectionName}
                        </td>
                        <td className="sticky-col">{firstRow?.platformname}</td>
                        <td className="sticky-col" style={{ width: "200px" }}>
                          <div className="metric-name">
                            {metricName}
                            <div className="metric-info">
                              <FaInfo
                                className="info-icon"
                                onClick={() =>
                                  fetchMetricsDefinition(
                                    metricName,
                                    firstRow?.platformname,
                                    firstRow?.metricid
                                  )
                                }
                              />
                            </div>
                            {selectedMetricDesc === metricName && (
                              <span className="metric-desc">{metricsDesc}</span>
                            )}
                          </div>
                        </td>
                        {brandsToDisplay.map((brand) => {
                          const brandData = rows.find(
                            (row) => row.brandName === brand
                          );
                          return (
                            <td
                              key={brand}
                              style={{ width: "100px" }}
                              title={`Benchmark Value: ${formatDecimalToFixed2(
                                brandData?.benchmarkValue
                              )}\nPercentile: ${formatDecimalToFixed2(
                                brandData?.percentile
                              )}`}
                            >
                              {brandData?.normalized || "-"}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {uniqueBrands.length > itemsPerPage && (
                <div className="pagination-container">
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="loader-container-sm">
              <div className="loader-sm"></div>
              <span className="loader-text">Loading...</span>
            </div>
          )}
        </>
      ),
    },
    {
      label: "Graph View",
      content: (
        <>
          <div className="row">
            <div className="col-12">
              <div className="graphic-buttons">
                <button
                  className="new-btn-graphic mkc"
                  onClick={() => handleComparisonGraphData("Marketplace")}
                >
                  <span
                    style={{
                      backgroundColor: getColor("Marketplace"),
                      borderRadius: "50%",
                      marginRight: "5px",
                      width: "10px",
                      height: "10px",
                    }}
                  ></span>
                  Marketplace
                </button>
                <button
                  className="new-btn-graphic ds"
                  onClick={() => handleComparisonGraphData("Digital Spends")}
                >
                  <span
                    style={{
                      backgroundColor: getColor("Digital Spends"),
                      borderRadius: "50%",
                      marginRight: "5px",
                      width: "10px",
                      height: "10px",
                    }}
                  ></span>
                  Digital Spends
                </button>
                <button
                  className="new-btn-graphic sc"
                  onClick={() => handleComparisonGraphData("Socialwatch")}
                >
                  <span
                    style={{
                      backgroundColor: getColor("Socialwatch"),
                      borderRadius: "50%",
                      marginRight: "5px",
                      width: "10px",
                      height: "10px",
                    }}
                  ></span>
                  Socialwatch
                </button>
                <button
                  className="new-btn-graphic op"
                  onClick={() =>
                    handleComparisonGraphData("Organic Performance")
                  }
                >
                  <span
                    style={{
                      backgroundColor: getColor("Organic Performance"),
                      borderRadius: "50%",
                      marginRight: "5px",
                      width: "10px",
                      height: "10px",
                    }}
                  ></span>
                  Organic Performance
                </button>
              </div>
            </div>
            {displayChartsData &&
              displayChartsData.length > 0 &&
              displayChartsData.map((chartData, index) => {
                const seriesData = chartData?.brands?.map((item) => ({
                  name: item.brand,
                  data: [parseFloat(item.normalized)],
                }));
                // const benchmarkValue = metricItems?.[0]?.benchmarkValue || 0;
                // const platformName = metricItems?.[0]?.platformname || "N/A";
                return (
                  <div
                    key={`chart-${index}`}
                    className="col-sm-12 col-md-6 col-lg-6 col-xl-3"
                  >
                    <div className="chart-box">
                      <div className="chart-heading">
                        <div className="chart-result">
                          <span className="item-title">Platform:</span>
                          {chartData.platform && (
                            <span className="item-result">
                              {chartData.platform}
                            </span>
                          )}
                        </div>
                        <div className="chart-result">
                          <span className="item-title">Metric:</span>
                          {chartData.metric && (
                            <span className="item-result">
                              {chartData.metric}
                            </span>
                          )}
                        </div>
                        {/* <div className="chart-result">
                    <span className="item-title">Benchmark:</span>
                    {chartData.benchmarkValue && (
                      <span className="item-result">
                        {formatDecimalToFixed2(chartData.benchmarkValue)}
                      </span>
                    )}
                  </div> */}
                      </div>
                      {/* <h4 className="text-center">{metricName}</h4> */}
                      <BarChart
                        series={seriesData}
                        categories={chartData.brands.map(
                          (brand) => brand.brand
                        )} // single dummy category
                        noDataText="No data available"
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      <div className="filter-options mb-2">
        <MultiSelectDropdown
          options={compareFilterCategories}
          selectedValues={compareSelectedFilterCategories}
          onChange={handleCompareFilterCategory}
          placeholder="Select Category"
        />
        <MultiSelectDropdown
          options={brandFilterOptions}
          selectedValues={compareSelectedFilterBrands}
          onChange={handleCompareFilterBrand}
          placeholder="Select Brand"
        />
      </div>
      <TabComponent
        tabs={nestedTabs}
        queryParam="nestedTab"
        isBenchmarkDataSaved={true}
        className="tabs-component"
      />
    </div>
  );
};

export default ComparisionView;
